import { hashKey, useQuery } from '@tanstack/react-query';

import { CompanyCriteria } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useForwarders = (criteria: CompanyCriteria) =>
  useQuery({
    queryKey: ['forwarders', hashKey([criteria])],
    queryFn: async () => {
      try {
        const result = await apiClient.forwarder.retrieveForwarders.mutation({ body: { criteria } });
        if (result.status === 200) {
          return result.body.forwarders;
        } else {
          throw new Error(`Unexpected response status: ${result.status}`);
        }
      } catch (error) {
        showErrorToast(error, 'Failed to fetch forwarders');
      }
    },
  });
